// src/services/axiosInstance.ts
import axios from "axios";
import { logout } from "./AuthService";

// Cria uma instância do Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Adiciona token automaticamente, se houver
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Intercepta respostas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRoute = error.config?.url?.includes("/login");
    const hasToken = localStorage.getItem("token");

    if (error.response?.status === 401 && hasToken && !isLoginRoute) {
      logout();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
